<template>
  <mobileHomePage v-if="isMobile"></mobileHomePage>
  <pcHomePage v-else></pcHomePage>
</template>

<script>
import mobileHomePage from "@/views/mobileHomePage";
import pcHomePage from "@/views/pcHomePage";
import device from '@/mx-service/libs/utils/device'

export default {
  components: {
    mobileHomePage,
    pcHomePage,
  },
  data(){
    return {
      isMobile: false,
    }
  },
  created(){
    this.isMobile = device.isMobile()
  }
}
</script>